import { makeStyles } from '@material-ui/core';

// Autocomplete makeStyles for Material-UI v4 compatibility
// Note: Paper and listbox styles are now applied via JavaScript in useAdminLearnerModalHook.js
export const useAutocompleteStyles = makeStyles((theme) => ({
  autocompleteRoot: {
    '& .MuiOutlinedInput-root': {
      width: '100%',
      maxWidth: '600px',
      borderRadius: '50px',
      paddingLeft: '16px',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0096CA',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0096CA',
        borderWidth: '2px',
      },
    },
    '& .MuiInputAdornment-root': {
      marginRight: '8px',
    },
    '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
      padding: '0px 4px 7.5px 0px !important',
    },
    '& .MuiAutocomplete-endAdornment': {
      display: 'none',
    },
    '& .MuiInputBase-input::placeholder': {
      color: 'var(--Greyscale---grey-90, #707070)',
      fontFamily: 'Inter',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '0.32px',
      opacity: 1,
    },
    '& .MuiChip-root': {
      backgroundColor: '#F3E8FF',
      color: '#A855F7',
      '& .MuiChip-deleteIcon': {
        color: '#A855F7',
        '&:hover': {
          color: '#7C3AED',
        },
      },
    },
  },
  noOptionsText: {
    color: 'var(--Navy---navy-main, #061E44)',
  },
}));
